module.exports = __webpack_public_path__ + "df90979636e5b4543efc62266800ba92.png";